export default "__VITE_ASSET__Fuh0TKsb__"